import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { openCookieSettings } from "@/components/CookieConsent";

export default function PublicFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-c mt-4" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-primary-c flex items-center justify-center text-white font-display">O</div>
            <span className="font-display text-lg">Oresto</span>
          </div>
          <p className="mt-3 text-xs text-text-secondary leading-relaxed max-w-[220px]">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wider text-text-secondary">{t("footer.product")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/produit" className="text-text-secondary hover:text-primary-c">{t("public_nav.product")}</Link></li>
            <li><Link to="/tarifs" className="text-text-secondary hover:text-primary-c">{t("public_nav.pricing")}</Link></li>
            <li><Link to="/faq" className="text-text-secondary hover:text-primary-c">{t("public_nav.faq")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wider text-text-secondary">{t("footer.company")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/a-propos" className="text-text-secondary hover:text-primary-c">{t("public_nav.about")}</Link></li>
            <li><Link to="/contact" className="text-text-secondary hover:text-primary-c">{t("public_nav.contact")}</Link></li>
            <li><Link to="/reserver" className="text-text-secondary hover:text-primary-c">{t("public_nav.book_call")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wider text-text-secondary">{t("footer.legal")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/cgv" className="text-text-secondary hover:text-primary-c">{t("footer.terms")}</Link></li>
            <li><Link to="/confidentialite" className="text-text-secondary hover:text-primary-c">{t("footer.privacy")}</Link></li>
            <li><Link to="/registre-traitements" className="text-text-secondary hover:text-primary-c">{t("footer.processing")}</Link></li>
            <li><Link to="/mentions-legales" className="text-text-secondary hover:text-primary-c">{t("footer.notice")}</Link></li>
            <li><button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings" className="text-text-secondary hover:text-primary-c">{t("footer.cookies")}</button></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-c">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
          <p className="text-xs text-text-secondary">{t("footer.copy")}<span className="block mt-1" data-testid="footer-publisher">{t("footer.publisher")}</span></p>
          <p className="text-xs text-text-secondary">{t("footer.made_with")}</p>
        </div>
      </div>
    </footer>
  );
}
